exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sau-select span.not-a-radio-button[data-v-0bb78e23] {\n  background-image: none !important;\n  width: auto !important;\n  height: auto !important;\n}", ""]);

// exports
